import { FC, useCallback, useContext, useEffect, useState } from "react";

import { Button, Buttons, Drawer } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Semibold } from "capitalrx-components-2.0/lib/typography";
import { formatDate } from "capitalrx-utilities";

import { getPCDocumentURLForDownload, logPCDocumentDownload } from "@/api"; import { AuthenticationContext } from "@/context";

import styles from "./DocumentsList.module.scss";


interface ProviderDocumentRowProps {
  DocumentType: String;
  DocumentName: String;
  DocumentEffectiveDate: String;
  DocumentUUID: string;
}

export const ProviderDocumentRow: FC<ProviderDocumentRowProps> = ({ DocumentType, DocumentName, DocumentEffectiveDate, DocumentUUID }) => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const authToken = getAuthToken();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleDownloadClick = async (documentUuid: string) => {
    const presignedResponse = await getPCDocumentURLForDownload({ uuid: documentUuid }, authToken);
    const { url } = presignedResponse;
    if (url) {
      window.open(url, "_self");
    }
    await logPCDocumentDownload(DocumentType, authToken);
  };

  const viewHandler = useCallback(() => {
     setDrawerVisible(true);
   }, []);

  const drawerCloseHandler = useCallback(() => {
    setDrawerVisible(false);
  }, []);

  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const isPdfFilename = (file: String) => file.split(".").pop().toLowerCase() === "pdf";

  useEffect(() => {
    const fetchPdfUrl = async () => {
      if (drawerVisible && DocumentUUID !== null) {
        try {
          const response = await getPCDocumentURLForDownload({ uuid: DocumentUUID.toString(), disposition: "inline", content_type: "application/pdf" }, authToken);
          setPdfUrl(`${response.url}#toolbar=0`);
        } catch (error) {
          console.error("Failed to fetch PDF URL", error);
          setPdfUrl(null);
        }
      }
    };

    fetchPdfUrl();
  }, [drawerVisible, DocumentUUID, authToken]);


  return (
    <Shelf className={styles.DocumentRow}>
      <Stack spacing="mini">
        <Semibold>{DocumentName}</Semibold>
        <Shelf>{formatDate(DocumentEffectiveDate, "MM/DD/YYYY")}<Shelf.Spacer />{DocumentType}</Shelf>
      </Stack>
      <Shelf.Spacer />
      <Button appearance={Buttons.Functional.Tertiary.Large} icon="download" onClick={() => handleDownloadClick(DocumentUUID.toString())} />
      {isPdfFilename(DocumentName) && (
        <Button appearance={Buttons.Functional.Tertiary.Large} icon="eye" onClick={viewHandler} />
      )}
      {drawerVisible && DocumentUUID !== null && (
        <Drawer
          size="ultra-wide"
          title={`${DocumentName}, ${formatDate(DocumentEffectiveDate, "MM/DD/YYYY")}`}
          visible={drawerVisible}
          onClose={drawerCloseHandler}
          footer={
            <Shelf>
              <Shelf.Spacer />
              <Button onClick={() => setDrawerVisible(false)}>Close</Button>
            </Shelf>
          }
        >
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="800px"
            />
          )}
        </Drawer>
      )}
    </Shelf>
  );
};

export default ProviderDocumentRow;
